<div class="container">
    <div class="meta"><span trans>Copyright &copy; 2018, All Rights Reserved,</span> <a [routerLink]="'/'">{{settings.get('branding.site_name')}}</a></div>
    <custom-menu position="footer"></custom-menu>
</div>